export const renderPdfIntoTab = (base64String: string, newTab: Window): void => {
  const pdfUrl = createPdfUrl(base64String);
  newTab.location.href = pdfUrl;
  newTab.addEventListener('beforeunload', () => {
    URL.revokeObjectURL(pdfUrl);
  });
};

export const openEmptyTab = (): Window => {
  const newWindow = window.open('', '_blank');

  newWindow.document.body.innerHTML = '<p>Das Dokument wird geladen.</p>';

  return newWindow;
};

export const createPdfUrl = (b64Data: string): string => {
  const byteCharacters = atob(b64Data);
  const byteNumbers = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([byteNumbers], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
};
